module.exports = __webpack_public_path__ + "img/VIR.241376e9.gif";